import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import SearchBar from '../../../Components/Utility/FilterAction/SearchBar';
import OrderTable from './OrderTable';
import { useComponentOrderState } from '../ComponentProvider';
import Loader from '../../../Components/Utility/Loader/Loader';
import AddPurchaseOrder from './AddPurchaseOrder';
import * as componentAction from '../store/component.action';
import { AddIcon } from '../../../bombiix-icon';

function OrderList() {
  const dispatch = useDispatch();
  const params = useParams();
  const supplierType = params?.supplierType;
  const { t } = useTranslation('common');

  const { Componentstate, setComponentState } = useComponentOrderState();
  useEffect(() => {
    return () => {
      setComponentState((prev) => ({
        ...prev,
        PurchaseOrderData: [],
        pageIndex: 1,
        hasMore: false,
        searchText: '',
      }));
      dispatch(componentAction.clearReducer());
    };
  }, []);
  const handleTemplateSearch = (value) => {
    setComponentState((prev) => ({
      ...prev,
      searchText: value,
      searchLoaded: true,
    }));
  };

  const openAddModal = () => {
    setComponentState((prev) => ({
      ...prev,
      addPOModal: true,
    }));
  };

  const hideAddModal = async () => {
    setComponentState((prev) => ({
      ...prev,
      addPOModal: false,
      PurchaseOrderData: [],
      pageIndex: 1,
      isLoading: true,
    }));

    const reqObj = {
      pageIndex: 1,
      pageSize: Componentstate?.pageSize,
    };
    if (Componentstate.sortOrder) {
      reqObj.sortOrder = Componentstate?.sortOrde;
      reqObj.sortPropertyName = Componentstate?.sortPropertyName;
    }

    const res = await dispatch(componentAction.fetchPurchaseOrder(reqObj));
    if (res) {
      setComponentState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container max-w-260">
          <h4 className="title w-xs-200px">{t('PURCHASE_ORDER_NUMBER.PURCHASE_ORD')}</h4>
        </div>
        <div className="search-filter">
          <SearchBar
            placeholder={t('PURCHASE_ORDER_NUMBER.SEARCH_COMPONETS')}
            onSearch={(e) => {
              handleTemplateSearch(e.target.value);
            }}
          />
          {!supplierType && (
            <button onClick={openAddModal} type="button" className="filter-btn filter-button_add">
              <AddIcon size={24} />
            </button>
          )}
        </div>
      </div>
      {Componentstate?.isLoading ? <Loader /> : <OrderTable supplierType={!!supplierType} />}
      {Componentstate?.addPOModal && <AddPurchaseOrder onOpen={Componentstate?.addPOModal} toggle={hideAddModal} />}
    </>
  );
}

export default OrderList;
